import React from 'react';
import { NavLink } from 'react-router-dom';

const SUB = [
  { to: '/about/history', label: 'History' },
  { to: '/about/founder', label: 'Founder' },
  { to: '/about/clients', label: 'Clients' }
];

const AboutSubNav = () => {
  return (
    <div className="sticky top-24 md:top-28 z-30 bg-[#faf6f0]/95 backdrop-blur-md border-b border-[#e8dfd1]" data-testid="about-subnav">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-1 md:gap-3 overflow-x-auto py-4 md:py-5">
          <p className="text-[10px] md:text-xs tracking-[0.32em] uppercase text-[#a67c3d] mr-4 md:mr-6 whitespace-nowrap">About &mdash;</p>
          {SUB.map(s => (
            <NavLink
              key={s.to}
              to={s.to}
              end
              className={({ isActive }) =>
                `px-4 md:px-5 py-2 text-xs md:text-sm tracking-[0.14em] uppercase transition-colors duration-300 whitespace-nowrap ${
                  isActive
                    ? 'text-[#1a1614] font-medium border-b border-[#a67c3d]'
                    : 'text-[#6b5847] hover:text-[#1a1614]'
                }`
              }
            >
              {s.label}
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutSubNav;
